// Fallback: valores historicos, inlinados pelo CRA em build time via REACT_APP_ENV.
// Continuam valendo quando nao ha config de runtime (ex: `npm start`, ou pod sem as
// env vars vindas do Infisical) - ou seja, o comportamento de hoje fica intacto.
const configs = {
    production: {
        baseUrl: 'https://api.arescontrol.com.br',
        wsUrl: 'wss://ws.arescontrol.com.br'
    },
    homolog: {
        baseUrl: 'https://apihomolog.arescontrol.com.br',
        wsUrl: 'wss://wshomolog.arescontrol.com.br'
    },
    local: {
        baseUrl: 'http://localhost:3331',
        wsUrl: 'wss://ws.arescontrol.com.br'
    },
}

// Config de RUNTIME. O /config.js e gerado pelo entrypoint do container a partir das
// env vars do pod e carregado no <head> do index.html, ANTES do bundle - o que importa
// porque services/Api.js monta o axios com o baseURL ja no import do modulo.
// Se o arquivo nao existir ou vier vazio, isto e {} e tudo cai no fallback acima.
const runtime = (typeof window !== 'undefined' && window.__ARES_CONFIG__) || {};

// Lazy de proposito: so resolve o fallback se o runtime nao tiver o valor. Assim, com
// a config de runtime presente, um REACT_APP_ENV invalido deixa de estourar o
// TypeError de configs[undefined].
const fromBuild = (key) => configs[process.env.REACT_APP_ENV][key];

export default {
    // NAO sobrescrito pelo runtime de proposito: services/Api.js usa getEnv() para
    // decidir se aplica a expiracao de sessao (env != 'local'). Trocar isso em runtime
    // mudaria silenciosamente o comportamento de logout.
    getEnv: () => {
        return process.env.REACT_APP_ENV;
    },
    getBaseUrl: () => {
        return runtime.baseUrl || fromBuild('baseUrl');
    },
    getWsUrl: () => {
        return runtime.wsUrl || fromBuild('wsUrl');
    },
    getConfigs: () => {
        return configs;
    },
    getAppVersion: () => {
        return process.env.REACT_APP_VERSION;
    }
}
